/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from "vue";
import VueAnalytics from "vue-analytics";
import Meta from "vue-meta";
import Router from "vue-router";
// import firebase from 'firebase/auth'
import { firebaseAuth } from "../firebase/firebaseAuth";

// Routes
import paths from "./paths";

import store from "../store/index";

function route(path, meta, view, name) {
  return {
    name: name || view,
    path,
    meta,
    component: (resovle) => import(`@/views/${view}.vue`).then(resovle),
  };
}

Vue.use(Router);

// Create a new router
const router = new Router({
  mode: "history",
  routes: paths
    .map((path) => route(path.path, path.meta, path.view, path.name))
    .concat([{ path: "*", redirect: "/dashboard" }]),
  scrollBehavior(to, from, savedPosition) {
    // console.log('scrollBehavior: ', savedPosition)
    // console.log('from: ', from)
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const currentUser = firebaseAuth.currentUser;
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const publicRoute = to.matched.some((record) => record.meta.public);
  const requiresGroup = to.matched.some((record) => record.meta.requiresGroup);

  if (publicRoute) {
    store.dispatch("setPublicRouteAction", true);
    next();
    return;
  } else {
    store.dispatch("setPublicRouteAction", false);
  }
  if (requiresAuth && currentUser) {
    if (requiresGroup) {
      if (!store.state.user?.id) {
        return;
      }
      const allowed_groups = to.meta.requiresGroup.some((item) =>
        store.state?.user?.group?.includes(item),
      );
      if (allowed_groups) {
        next();
      } else {
        // Direciona usuário para página recomendada para seu perfil
        if (store.state.user?.group) {
          if (
            store.state.user.group.includes("admin") ||
            store.state.user.group.includes("financial") ||
            store.state.user.group.includes("partner")
          ) {
            next("/dashboard");
          } else if (
            store.state.user.group.includes("sales") ||
            store.state.user.group.includes("sales_partner") ||
            store.state.user.group.includes("sales_management") ||
            store.state.user.group.includes("sales_partner_management")
          ) {
            next("/vendas");
          } else if (
            store.state.user.group.includes("customer_care") ||
            store.state.user.group.includes("collection") ||
            store.state.user.group.includes("eletron") ||
            store.state.user.group.includes("external_collection")
          ) {
            next("/atendimento");
          } else if (store.state.user.group.includes("access_grantor")) {
            next("/configuracao/usuarios");
          } else if (store.state.user.group.includes("marketing")) {
            next("/leads");
          } else {
            next("/membros/faturas/" + store.state.user.id);
          }
        } else {
          next("/login");
        }
      }
    } else {
      next();
    }
  } else if (requiresAuth && !currentUser) {
    next("/login");
  } else {
    next("/login");
  }
});

Vue.use(Meta);

// Bootstrap Analytics
// Set in .env
// https://github.com/MatteoGabriele/vue-analytics
if (process.env.GOOGLE_ANALYTICS) {
  Vue.use(VueAnalytics, {
    id: process.env.GOOGLE_ANALYTICS,
    router,
    autoTracking: {
      page: process.env.NODE_ENV !== "development",
    },
  });
}

export default router;
